export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-checkbox/index.js